// src/components/AIZoneSidebar.ts
import "./AIZoneSidebar.css";

export function renderAIZoneSidebar(container: HTMLElement) {
  container.innerHTML = `
    <div class="ai-sidebar" id="ai-sidebar">
      <!-- Sidebar Header -->
      <div class="sidebar-topbar">
        <button class="toggle-btn" id="sidebar-toggle">☰</button>
        
        <div class="logo" id="sidebar-logo">
          A
        </div>
      </div>

      <!-- Signed Out Section -->
      <div class="sidebar-signed-out">
        <div class="user-icon-container">
          <div class="user-icon-slash">👤</div>
        </div>

        <h3>You're signed out</h3>
        <p>To access history and more, sign in to your account</p>

        <button class="sidebar-signin-btn" id="sidebar-signin-btn">
          Sign In
        </button>
      </div>
    </div>
  `;

  setupSidebarEvents();
}

function setupSidebarEvents() {
  const sidebar = document.getElementById("ai-sidebar");
  const toggleBtn = document.getElementById("sidebar-toggle");
  const logo = document.getElementById("sidebar-logo");
  const signinBtn = document.getElementById("sidebar-signin-btn");

  if (!sidebar || !toggleBtn) return;

  // Toggle Sidebar
  toggleBtn.addEventListener("click", () => {
    sidebar.classList.toggle("open");
    toggleBtn.textContent = sidebar.classList.contains("open") ? "✕" : "☰";
  });

  // Click logo → Go Home
  logo?.addEventListener("click", () => {
    window.location.href = "/";
  });

  // Sign In Button
  signinBtn?.addEventListener("click", () => {
    const next = encodeURIComponent(window.location.href);
    window.location.assign(
      `https://api.ayesearch.com/auth/ayesearch/login/?next=${next}`,
    );
  });
}
